import React, { Component } from "react";
import axios from "axios";
import { ENDPOINT } from "../../utils/index";
import { MAX_EMBED_GALLERY_ASSETS } from "../bunkey-host/embedSnippet";
import { resolveMedia } from "./embedMedia";
import EmbedCarousel from "./EmbedCarousel";
import "./bunkeyHostEmbed.css";

const OBJECT_ID = /^[a-f\d]{24}$/i;

// La URL la puede editar cualquiera a mano: el tope acá es lo que evita que un
// embed pegado en un sitio ajeno dispare 50 peticiones al endpoint público.
export const parseIds = raw => {
  if (!raw) return [];
  const seen = {};
  const out = [];
  raw.split(",").forEach(part => {
    const id = part.trim();
    if (!OBJECT_ID.test(id) || seen[id]) return;
    seen[id] = true;
    out.push(id);
  });
  return out.slice(0, MAX_EMBED_GALLERY_ASSETS);
};

export class BunkeyHostEmbedGallery extends Component {
  constructor(props) {
    super(props);
    this.state = { status: "loading", items: [] };
  }

  componentDidMount() {
    document.documentElement.classList.add("bunkey-embed");
    document.body.classList.add("bunkey-embed");

    const { ids, quality } = this.props.match.params;
    const parsed = parseIds(ids);

    if (!parsed.length) {
      this.setState({ status: "notfound" });
      return;
    }

    // Un asset borrado no debe llevarse la galería entera: cada uno resuelve
    // por su cuenta y se muestran los que sí cargaron.
    Promise.all(
      parsed.map(id =>
        axios
          .get(`${ENDPOINT}embed/${id}`)
          .then(resp => (resp && resp.data && resp.data.result) || null)
          .catch(() => null)
      )
    ).then(results => {
      const items = results
        .filter(Boolean)
        .map(data => ({ data, media: resolveMedia(data, quality) }));

      this.setState({ status: items.length ? "ready" : "notfound", items });
    });
  }

  componentWillUnmount() {
    document.documentElement.classList.remove("bunkey-embed");
    document.body.classList.remove("bunkey-embed");
  }

  renderContent() {
    const { status, items } = this.state;

    if (status === "loading") return <div className="bk-embed__spinner" />;
    if (status === "ready") return <EmbedCarousel items={items} />;

    return (
      <div className="bk-embed__placeholder">
        <span>Contenido no disponible.</span>
      </div>
    );
  }

  render() {
    return <div className="bk-embed">{this.renderContent()}</div>;
  }
}

export default BunkeyHostEmbedGallery;
